import { render } from "./AsetPerusahaanDetail.vue?vue&type=template&id=468d61fa"
import script from "./AsetPerusahaanDetail.vue?vue&type=script&lang=js"
export * from "./AsetPerusahaanDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__